import React from 'react';
import { Contact } from '@/components/sections/Contact';

export const ContactPage: React.FC = () => {
  return (
    <main>
      <Contact standalone />
    </main>
  );
};

export default ContactPage;
